var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNmap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b3e5fc",
    d: "M44.104,21.491C41.236,20.16,34,13,24,13S6.764,20.16,3.896,21.491C0.564,23.037,0,25,0,26s1,3,5,3 s12.041,5.368,15,5.862c2.922,0.488,4,0.336,4,0.336s1.078,0.152,4-0.336C30.959,34.368,39,29,43,29s5-2,5-3 S47.436,23.037,44.104,21.491z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#81d4fa",
    d: "M5,29c4,0,12.041,5.368,15,5.862c2.922,0.488,4,0.336,4,0.336s1.078,0.152,4-0.336 C30.959,34.368,39,29,43,29s5-2,5-3H0C0,27,1,29,5,29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1f5fe",
    d: "M38.24,22.439C34.58,19.87,30.851,17.001,24,17v0c0,0-0.001,0-0.001,0s-0.001,0-0.001,0v0 c-6.851,0.001-10.58,2.87-14.24,5.439C6.75,24.549,3.997,25.31,3.997,26c0,1,0.943,0.515,3.009,0.828 C9,27.13,17.998,31.69,23.998,31.692v0c0,0,0.001,0,0.001,0s0.001,0,0.001,0v0c6-0.001,14.998-4.561,16.992-4.863 C43.058,26.515,44.001,27,44.001,26C44.001,25.31,41.248,24.549,38.24,22.439z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#81d4fa",
    d: "M33,23c0-1.626-0.438-3.147-1.192-4.464C29.671,17.62,27.173,17,24,17v0c0,0-0.001,0-0.001,0 s-0.001,0-0.001,0v0c-3.171,0-5.669,0.619-7.805,1.535C15.438,19.852,15,21.373,15,23c0,3.725,2.263,6.922,5.49,8.289 c1.228,0.248,2.418,0.402,3.508,0.402v0c0,0,0.001,0,0.001,0s0.001,0,0.001,0v0c1.091,0,2.282-0.154,3.511-0.403 C30.737,29.921,33,26.725,33,23z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23.5,
    r: 3.5,
    fill: "#455a64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23.5,
    r: 1,
    fill: "#b3e5fc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 1,
    fill: "#e1f5fe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M7.908,25.255c-0.21-0.475-0.703-0.771-1.269-0.957C5.085,25.104,3.997,25.566,3.997,26 c0,1,0.943,0.515,3.009,0.828c0.124,0.019,0.276,0.054,0.452,0.104C7.886,26.479,8.191,25.895,7.908,25.255z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M40.09,25.258c0.21-0.475,0.703-0.771,1.269-0.957c1.554,0.807,2.642,1.269,2.642,1.703 c0,1-0.943,0.515-3.009,0.828c-0.124,0.019-0.276,0.054-0.452,0.104C40.111,26.483,39.807,25.899,40.09,25.258z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmap);
export default __webpack_public_path__ + "static/media/nmap.cca8d423daf636e141fc5bf70c3603a1.svg";
export { ForwardRef as ReactComponent };